import { ConcreteEncodable } from "./ConcreteEncodable";

import { ModelUpdateImplEncoder } from "../../encoder/ModelUpdateImplEncoder";

import * as CubiqTS from "../../index";
import { ModelUpdate } from "../ModelUpdate";

export class ModelUpdateImpl extends ConcreteEncodable implements ModelUpdate {
  public static enType: string = "com.bcdfx.model.event.ModelUpdateImpl";

  /*FID=1*/
  public entityType: string;
  /*FID=2*/
  public payLoad: CubiqTS.ModelObject | null = null;
  /*FID=3*/
  public eventType: CubiqTS.ModelUpdateType;
  /*FID=100*/
  public messageId: string;
  public sessionOnly: string;

  constructor() {
    super();
    this.encoder = ModelUpdateImplEncoder.Instance;
    this.setEncodableType(ModelUpdateImpl.enType);
    //Model
  }

  public toString(): string {
    return (
      "ModelUpdateImpl[" +
      "entityType=" +
      this.entityType +
      "payLoad=" +
      this.payLoad +
      "eventType=" +
      this.eventType +
      "messageId=" +
      this.messageId +
      "]"
    );
  }

  public validateInbound(): void {}

  public validateOutbound(): void {}
}
